import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import imgLogo from "../../../../../image/logo.png";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import RichTextEditor from "react-rte";
import ReactTextArea from "../../../Components/ReactTextediter/ReactTextArea";
// import "./CreateArticle.css";

import csvParser from "papaparse";

// components
import FormField from "../../../Components/FormField/FormField";
import apidsf from "../../../../../utils/apidsf";


const ChechKeys = (object) => {
  console.log(object);
  return (
    object.hasOwnProperty("title") &&
    object.hasOwnProperty("optionOne") &&
    object.hasOwnProperty("optionTwo") &&
    object.hasOwnProperty("optionThree") &&
    object.hasOwnProperty("optionFour") &&
    object.hasOwnProperty("rightAnswer") &&
    object.hasOwnProperty("solution_description")
  );
};


const mocktestSubjectlist = [
  "Please Select Subject Name",
  "Constitution of India",
  "IPC",
  "Case law MCQs",
  "Cr.PC",
  "CPC",
  "Indian Evidence Act",
  "Indian Contract Act",
  "Indian Partnership Act",
  "Sales Of Goods Act",
  "Indian Limitation Act",
  "Transfer Of Property Act",
  "Companies Act 2013",
  "Law of Torts",
  "Hindu Family Laws",
  "Hindu Marriage Act",
  "Hindu Succession Act",
  "Hindu Adoption And Maintenance Act",
  "Hindu Minority And Guardianship Act",
  "Negotiable Instrument Act 1881",
  "Specific Relief Act 1963",
  "Arbitration And Conciliation Act",
  "NDPS Act",
  "Protection Of Children From Sexual Offence Act",
  "Intellectual Property Laws",
  "Motor Vehicle Act ",
  "Electricity Act 2003",
  "Family Courts Act 1984",
  "Environment Protection Act",
  "Wildlife Protection Act 1972",
  "SC & ST Act, 1989",
  "Prevention Of Corruption Act",
  "Registration Act",
  "Contempt Of Courts Act",
  "Prohibition Of Child Marriage Act",
  "Consumer Protection Act",
  "Right To Information Act",
  "Child And Adolescent Labour (Prohibition And Regulation) Act",
  "The Advocates Act 1961",
  "Special Marriage Act 1954",
  "Juvenile Justice Care And Protection Of Children Act 2015",
  "Arms Act 1959",
  "Real Estate (Regulation And Development) Act 2016",
  "Protection Of Women From Domestic Violence Act 2005",
  "Contempt Of Courts Act 1971",
  "Indian Succession Act 1925",
  "Prevention Of Money Laundering Act 2002",
  "Probation Of Offenders Act 1958",
  // "DISSOLUTION OF MUSLIM MARRIAGES ACT, 1939 - (Muslim Law)",
  // "MUSLIM PERSONAL LAW (SHARIAT) APPLICATION ACT, 1937",
  // "MUSLIM WOMEN (PROTECTION OF RIGHTS ON DIVORCE) ACT, 1986",
  // "MUSLIM WOMEN (PROTECTION OF RIGHTS ON MARRIAGE) ACT, 2019",
  "Law of Equity",
  "Law of Easement Act, 1882",
  "Indian Trust Act, 1882",
  "Provincial Smart Cause Courts Act, 1887",
  "Protection Of Human Rights Act 1993",
  "Electricity Act 2003",
  "Information Technology Act 2000",
  "Legal Services Authorities Act 1987",
  "Protection Of Civil Rights Act 1955",
  "Indian Forest Act 1927",
  "Indian Stamp Act 1899",
  "Court Fee Act 1870",
  "Excise Act",
  "Central Vigilance Commission Act 2003",
  "Industrial Disputes Act 1947",
  "Police Act 1961",
  "Delhi Special Police Establishment Act 1946",
  "Indian Christian Marriage Act 1872",
  "Divorce Act 1869",
  // New Subjects
  "Muslim Law",
  "Jurisprudence",
  "Administrative Law",
  "Public International Laws",
  "Human Rights' Laws",
  "Legal Terms, Maxims and Doctrines",
  "Bharatiya Nyaya Sanhita (BNS), 2023",
  "Bharatiya Nagarik Suraksha Sanhita (BNSS), 2023",
  "Bharatiya Sakshya Adhiniyam (BSA), 2023"

];


export default function CreateMockTest() {
  const params = useParams();
  const navigate = useNavigate();

  const [isExcel, setisExcel] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  //const [id, setId] = useState("");
  const [textareadata, settextdata] = useState({
    value: RichTextEditor.createEmptyValue(),
  });
  const [show, setShow] = useState({
    showState: false,
    showMockTest: false,
    showUni: false,
    showExam: false,
    loading: false,
    examSelect: false,
    ugcSubject: false,
    showllbExam: false,
  });
  const [formData, setFormData] = useState({
    title: "",
    reactTeaxttitle: RichTextEditor.createEmptyValue(),
    reactTeaxtdescription: RichTextEditor.createEmptyValue(),
    optionOne: "",
    optionTwo: "",
    optionThree: "",
    optionFour: "",
    rightAnswer: "",
    type: "exam",
    exam_subject: "",
    exam_type: "",
    ugc_subject: "",
    subjectSet: "Legal Aptitude",

    state: "",
    university: "",
    mock_test_no: "",
  });
  const {
    optionOne,
    title,
    solution_description,
    reactTeaxttitle,
    reactTeaxtdescription,

    optionTwo,
    optionThree,
    optionFour,
    rightAnswer,
    type,
    exam_subject,
    exam_type,
    ugc_subject,
    state,
    university,
    subjectSet,
    mock_test_no,
  } = formData;
  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const createOrUpdateLandmark = async () => {
      try {
        let res = null;

        if (isExcel == "true") {
          console.log("Entering Excel data");
          const reqBody = {
            exam_subject: formData.exam_subject,
            exam_type: formData.exam_type,
            mock_test_no: formData.mock_test_no,
            state: formData.state,
            subjectSet: formData.subjectSet,
            type: formData.type,
            ugc_subject: formData.ugc_subject,
            university: formData.university
          };

          let finalData = [];

          csvParser.parse(selectedFile, {
            skipEmptyLines: true,
            header: true,
            complete: (result) => {
              finalData = convetData(result, reqBody, async (data) => {
                try {
                  res = await api.post(
                    "/admin/mocktest/addMocktestExcel",
                    { data: data },
                    config
                  );
                  console.log({ res });
                  clearFileInput();

                  if (res.status == 200) {
                    swal({
                      title: "Pyq Added",
                      text: "Pyq Added Successfully",
                      icon: "success",
                    });
                    setShow({
                      ...show,
                      loading: false,
                    });
                  }
                } catch (err) {
                  console.log(err);
                  swal({
                    title: "!Error",
                    text: err.response.data.error.message,
                    icon: "error",
                  });
                  console.log({ err });
                }
              });
            },
            error: (err) => {
              console.log(err);
              swal({
                title: "Error",
                text: "Invalid CSV Format",
                icon: "error",
              });
              setShow({
                ...show,
                loading: false,
              });
            },
          });

          console.log({ finalData });

          return;
        }


        if (id) {
          res = await api.put(`/admin/mocktest/${id}`, formData, config);
        } else {
          res = await api.post("/admin/mocktest/", formData, config);
        }
        const data = res.data.data;

        if (data && id) {
          swal({
            title: "Mock Test Updated",
            text: "Mock Test Updated Successfully",
            icon: "success",
          });
          navigate("/admin/mocktest-table");
        } else {
          setFormData({
            ...formData,
            title: "",
            reactTeaxttitle: RichTextEditor.createEmptyValue(),
            reactTeaxtdescription: RichTextEditor.createEmptyValue(),
            optionOne: "",
            optionTwo: "",
            optionThree: "",
            optionFour: "",
            rightAnswer: "",
            type: "exam",
            subjectSet: "",

            exam_subject: "",
            exam_type: "",
            ugc_subject: "",
            state: "",
            university: "",
            mock_test_no: "",
          });
          swal({
            title: "Mock Test Added",
            text: "Mock Test Added Successfully",
            icon: "success",
          });
          // show error
        }
      } catch (err) {
        console.error(err.response.data.error);
        swal({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
        });
      }
    };
    createOrUpdateLandmark();
  };
  const [subjectlist, setsubjectlist] = useState([]);
  const getSubject = () => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    apidsf.get("/admin/getsubject", config).then((e) => {
      console.log(e);
      setsubjectlist(e?.data?.Subject);
    });
  };
  useEffect(() => {
    getSubject();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const fetchLandmark = async () => {
      const res = await api.get(`/mocktest/?_id=${id}`, config);
      const data = res.data.data[0];

      const {
        optionOne,
        title,
        reactTeaxttitle,
        reactTeaxtdescription,
        solution_description,
        optionTwo,
        optionThree,
        optionFour,
        rightAnswer,
        type,
        exam_subject,
        exam_type,
        ugc_subject,
        state,
        university,
        mock_test_no,
        subjectSet,
      } = data;
      checkSelectValue(exam_subject);
      setFormData({
        reactTeaxttitle: RichTextEditor.createValueFromString(title, "html"),
        reactTeaxtdescription: RichTextEditor.createValueFromString(
          solution_description,
          "html"
        ),

        title: title,
        solution_description: solution_description,
        optionOne: optionOne,
        optionTwo: optionTwo,
        optionThree: optionThree,
        optionFour: optionFour,
        rightAnswer: rightAnswer,
        type: type,
        exam_subject: exam_subject,
        exam_type: exam_type,
        ugc_subject: ugc_subject,
        state: state,
        university: university,
        subjectSet: subjectSet,

        mock_test_no: mock_test_no,
      });
    };

    if (id) {
      fetchLandmark();
    } else {
      setFormData({
        title: "",
        solution_description: "",
        reactTeaxttitle: RichTextEditor.createEmptyValue(),
        reactTeaxtdescription: RichTextEditor.createEmptyValue(),
        optionOne: "",
        optionTwo: "",
        optionThree: "",
        optionFour: "",
        rightAnswer: "",
        type: "exam",
        exam_subject: "",
        exam_type: "",
        ugc_subject: "",
        state: "",
        university: "",
        subjectSet: "",

        mock_test_no: "",
      });
    }
  }, [params]);

  const onChangeFunction = (value, Fieldname, valuename) => {
    let data = value.toString("html");
    setFormData({
      ...formData,
      [Fieldname]: data,
      [valuename]: value,
    });
  };
  const checkUgcSubject = (data) => {
    switch (data) {
      case "Paper Two":
        setShow({
          ...show,
          ugcSubject: true,
        });
        break;
      default:
        setShow({
          ...show,
          ugcSubject: false,
        });
    }
  };

  const checkSelectValue = (data) => {
    switch (data) {
      case "Judiciary":
        setShow({
          ...show,
          showState: true,
          showllbExam: false,
          showMockTest: true,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "ADA/APP/APO/JLO":
        setShow({
          ...show,
          showState: true,
          showMockTest: true,
          showllbExam: false,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "UGC NET":
        setShow({
          ...show,
          showState: false,
          showMockTest: true,
          showUni: false,
          showllbExam: false,
          showExam: false,
          examSelect: true,
          ugcSubject: false,
        });
        break;
      case "LLB Entrance":
        setShow({
          ...show,
          showState: false,
          showMockTest: true,
          showUni: false,
          showllbExam: true,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "LLM Entrance":
        setShow({
          ...show,
          showState: false,
          showMockTest: true,
          showUni: false,
          showExam: false,
          showllbExam: true,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "Phd in Law":
        setShow({
          ...show,
          showState: false,
          showMockTest: true,
          showllbExam: false,
          showUni: true,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "AIBE":
        setShow({
          ...show,
          showState: false,
          showMockTest: true,
          showUni: false,
          showllbExam: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "Law Officer":
        setShow({
          ...show,
          showState: false,
          showMockTest: false,
          showllbExam: false,
          showUni: false,
          showExam: true,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      default:
        setShow({
          ...show,
          showState: false,
          showMockTest: false,
          showllbExam: false,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
    }
  };

  const convetData = async (result, restData, callbackFunc) => {
    let paresedData = [];
    let excelData = result.data;
    const isValid = ChechKeys(excelData[0]);
    if (isValid) {
      for (let data of excelData) {
        console.log({ data });
        paresedData.push({ ...restData, ...data });
      }
      console.log({ paresedData });
      callbackFunc(paresedData);
    } else {
      swal({
        title: "Error",
        text: "Invalid CSV Format",
        icon: "error",
      });
      setShow({
        ...show,
        loading: false,
      });
    }
  };

  const clearFileInput = () => {
    const fileInput = document.querySelector(".Excel__fileInput");
    console.log(fileInput.childNodes);
    fileInput.childNodes[1].value = "";
    setSelectedFile(null);
  };


  console.log(formData);
  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handleSubmit}>
        <div className="userUpdateLeft">
          <div className="userUpdateItem">
            <label className="user__label">Select Subject Set</label>
            <select
              value={subjectSet}
              onChange={(e) => {
                return setFormData({
                  ...formData,
                  subjectSet: e.target.value,
                });
                // console.log(e.target.value);
              }}
            >
              <option value={undefined}>Select Subject Set</option>
              {subjectlist.map((e) => {
                return (
                  <option value={e.subject_name}>{e.subject_name}</option>
                  // <option value="Law">Law</option>
                );
              })}
            </select>
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Select Type</label>
            <select
              value={type}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  type: e.target.value,
                });
                if (e.target.value == "subject") {
                  setShow({
                    ...show,
                    showState: false,
                    showMockTest: false,
                    showllbExam: false,
                    showUni: false,
                    showExam: false,
                    examSelect: false,
                    ugcSubject: false,
                  });
                }
              }}
            >
              <option value="exam">Exam</option>
              <option value="subject">Subject</option>
            </select>
          </div>

          {formData?.type == "exam" ? (
            <div className="userUpdateItem">
              <label className="user__label">Exam Subject</label>
              <select
                value={exam_subject}
                onChange={(e) => {
                  checkSelectValue(e.target.value);
                  setFormData({
                    ...formData,
                    exam_subject: e.target.value,
                  });
                }}
              >
                <option value=" ">Select Exam Subject</option>
                <option value="Judiciary">Judiciary</option>
                <option value="ADA/APP/APO/JLO">ADA/APP/APO/JLO</option>
                <option value="UGC NET">UGC NET</option>
                <option value="LLB Entrance">LLB Entrance</option>
                <option value="LLM Entrance">LLM Entrance</option>
                <option value="Phd in Law">Phd in Law</option>
                <option value="AIBE">AIBE</option>
                <option value="Law Officer">Law Officer</option>
              </select>
            </div>
          ) : (
            <div className="userUpdateItem">
              <label className="user__label">Subject</label>
              <select
                value={exam_subject}
                onChange={(e) => {
                  setShow({
                    ...show,
                    showMockTest: true,
                  });
                  setFormData({
                    ...formData,
                    exam_subject: e.target.value,
                  });
                }}
              >
                {mocktestSubjectlist.map((item) =>
                  <option value={item}>
                    {item}
                  </option>
                )}
              </select>
            </div>
          )}
          {show.examSelect ? (
            <div className="userUpdateItem">
              <label className="user__label">Exam Type</label>
              <select
                value={exam_type}
                onChange={(e) => {
                  checkUgcSubject(e.target.value);
                  setFormData({
                    ...formData,
                    exam_type: e.target.value,
                  });
                }}
              >
                <option value=" ">Select Exam</option>
                <option value="Paper One">Paper One</option>
                <option value="Paper Two">Paper Two</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.ugcSubject ? (
            <div className="userUpdateItem">
              <label className="user__label">UGC Subject</label>
              <select
                value={ugc_subject}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    ugc_subject: e.target.value,
                  });
                }}
              >
                <option value=" ">Select Subject</option>
                <option value="Law">Law</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.showllbExam ? (
            <div className="userUpdateItem">
              <label className="user__label">Exam Type</label>
              <select
                value={exam_type}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    exam_type: e.target.value,
                  });

                  if (e.target.value == "University") {
                    setShow({
                      ...show,
                      showUni: true,
                    });
                  } else {
                    setShow({
                      ...show,
                      showUni: false,
                    });
                  }
                }}
              >
                <option value="">Select Exam</option>
                <option value="CLAT">CLAT</option>
                <option value="LSAT">LSAT</option>
                <option value="University">University</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.showState ? (
            <FormField
              type="text"
              label="State"
              placeholder="State"
              value={state}
              name="state"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}
          {show.showUni ? (
            <FormField
              type="text"
              label="University"
              placeholder="University"
              value={university}
              name="university"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}
          {show.showExam ? (
            <FormField
              type="text"
              label="Exam Type"
              placeholder="Exam Type"
              value={exam_type}
              name="exam_type"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          {show.showMockTest ? (
            <FormField
              type="number"
              label="Mock Test no"
              placeholder="Mock Test no"
              value={mock_test_no}
              name="mock_test_no"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          <div className="ExcelChoice">
            <div>
              <input
                type="radio"
                name="selectType"
                value="true"
                onClick={(e) => {
                  console.log(e.target.value);
                  setisExcel(e.target.value);
                }}
              />
              <span>CSV</span>
            </div>

            <div>
              <input
                type="radio"
                name="selectType"
                value="false"
                onClick={(e) => {
                  console.log(e.target.value);
                  setisExcel(e.target.value);
                }}
              />
              <span> Manual</span>
            </div>
          </div>

          {isExcel == "true" && (
            <>
              <div className="Excel__fileInput">
                <label>Please Select a CSV file</label>
                <input
                  type="file"
                  name="excel"
                  accept="text/csv"
                  onChange={(e) => {
                    setSelectedFile(e.target.files[0]);
                    console.log(e.target.files[0]);
                  }}
                />
              </div>

              <div className="Excel__warning">
                Questions of above Fields will be overWritten this CSV
              </div>
            </>
          )}

          {isExcel == "false" &&

            (<>
              <ReactTextArea
                lable="Title"
                Fieldname="title"
                mainvalue={reactTeaxttitle}
                valuename="reactTeaxttitle"
                onChangeFunction={onChangeFunction}
              />

              <FormField
                type="text"
                label="Option One"
                placeholder="Option One"
                value={optionOne}
                name="optionOne"
                handleChange={handleInputChange}
              />
              <FormField
                type="text"
                label="Option Two"
                placeholder="Option Two"
                value={optionTwo}
                name="optionTwo"
                handleChange={handleInputChange}
              />
              <FormField
                type="text"
                label="Option Three"
                placeholder="Option Three"
                value={optionThree}
                name="optionThree"
                handleChange={handleInputChange}
              />
              <FormField
                type="text"
                label="Option Four"
                placeholder="Option Four"
                value={optionFour}
                name="optionFour"
                handleChange={handleInputChange}
              />
              <div className="userUpdateItem">
                <label className="user__label">Right Answer</label>
                <select
                  value={rightAnswer}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      rightAnswer: e.target.value,
                    });
                  }}
                >
                  <option value="0">None</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
              <ReactTextArea
                lable="Solution Description"
                Fieldname="solution_description"
                mainvalue={reactTeaxtdescription}
                valuename="reactTeaxtdescription"
                onChangeFunction={onChangeFunction}
              />

            </>)
          }

          <div>
            <button className="userUpdateButton" type="submit">
              {params.id ? "Update MockTest" : "Add MockTest"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
